"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.PrevisuCoinCadre = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var PrevisuCoinCadre = function PrevisuCoinCadre(props) {
  var _useState = (0, _react.useState)(false),
      loading = _useState[0],
      setLoading = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      loading2 = _useState2[0],
      setLoading2 = _useState2[1];

  var ba_id2 = props.baguetteInterieure !== null ? props.baguetteInterieure.ba_id : null;
  (0, _react.useEffect)(function () {
    if (props.baguetteInterieure !== null) {
      var _img = document.querySelector("[data-image-check-loading-doublo-" + uniqueId + "] img");

      setTimeout(function () {
        //setLoading2(!(img.complete && img.naturalHeight !== 0));
        setLoading2(false);
      }, 500);
    }
  }, [ba_id2]);

  var _useState3 = (0, _react.useState)(Math.floor(Math.random() * 0xffff)),
      uniqueId = _useState3[0];

  var img = typeof document !== "undefined" ? document.querySelector("[data-image-check-loading-" + uniqueId + "] img") : null;
  (0, _react.useEffect)(function () {
    if (img !== null) {
      setLoading(!(img.complete && img.naturalHeight !== 0));
    } else setLoading(false); // devrait être à true

  }, [img !== null ? img.complete : img]);
  var largeurPx = props.width;
  var hauteurPx = props.height;
  var baguette = props.baguette;
  var baguetteHauteurCm = parseFloat(baguette.ba_largeur);
  var fullWidthCm = props.pageProduit.largeur;
  var fullHeightCm = props.pageProduit.hauteur;
  var baguetteHauteurPx;
  var cadreLargeurPx;
  var cadreHauteurPx;

  if (fullWidthCm > fullHeightCm) {
    baguetteHauteurPx = baguetteHauteurCm * largeurPx / fullWidthCm;
    cadreLargeurPx = largeurPx;
    cadreHauteurPx = fullHeightCm * largeurPx / fullWidthCm;
  } else {
    baguetteHauteurPx = baguetteHauteurCm * hauteurPx / fullHeightCm;
    cadreLargeurPx = fullWidthCm * hauteurPx / fullHeightCm;
    cadreHauteurPx = hauteurPx;
  } //Largeur des petits carrés permettant de dessiner les traits dans les coins


  var largeurCarres = Math.sqrt(2 * (baguetteHauteurPx * baguetteHauteurPx));
  var styleCadre = {
    position: "relative",
    width: cadreLargeurPx,
    height: cadreHauteurPx,
    overflow: "hidden",
    backgroundColor: "transparent",
    filter: "drop-shadow(2px 2px 4px #555)"
  }; // DIV IMAGES :

  var styleDivHaut = {
    position: "absolute",
    width: cadreLargeurPx,
    left: 0,
    height: baguetteHauteurPx,
    overflow: "hidden",
    zIndex: 2,
    clipPath: "polygon(0 0, " + cadreLargeurPx + "px 0, " + cadreLargeurPx + "px " + baguetteHauteurPx + "px, " + baguetteHauteurPx + "px " + baguetteHauteurPx + "px)"
  };
  var styleDivGauche = {
    position: "absolute",
    width: baguetteHauteurPx,
    height: largeurPx,
    left: 0,
    top: 0,
    overflow: "hidden",
    zIndex: 2,
    clipPath: "polygon(" + baguetteHauteurPx + "px " + baguetteHauteurPx + "px, 0 0, 0 " + cadreHauteurPx + "px, " + baguetteHauteurPx + "px " + cadreHauteurPx + "px)"
  }; // IMAGES :

  var styleImageHaut = {
    position: "absolute",
    width: largeurPx,
    left: 0,
    height: baguetteHauteurPx + "px",
    boxShadow: "1px 1px 5px rgb(85, 85, 85, 0.5)"
  };
  var styleImageGauche = {
    position: "absolute",
    top: largeurPx,
    left: 0,
    width: largeurPx,
    transformOrigin: "top left",
    transform: "rotate(-90deg)",
    height: baguetteHauteurPx + "px",
    boxShadow: "1px 1px 5px rgb(85, 85, 85, 0.5)"
  };
  var baguetteHauteurPx2, styleDivHaut2, styleDivGauche2, styleImageHaut2, styleImageGauche2;

  if (props.baguetteInterieure !== null) {
    var recouvrement = null;

    if (fullWidthCm > fullHeightCm) {
      baguetteHauteurPx2 = props.baguetteInterieure.ba_largeur * largeurPx / fullWidthCm;
      recouvrement = (baguette.ba_largeur - baguette.ba_talon) * largeurPx / fullWidthCm;
    } else {
      baguetteHauteurPx2 = props.baguetteInterieure.ba_largeur * hauteurPx / fullHeightCm;
      recouvrement = (baguette.ba_largeur - baguette.ba_talon) * hauteurPx / fullHeightCm;
    }

    var cadreLargeurPx2 = cadreLargeurPx;
    var cadreHauteurPx2 = cadreHauteurPx; //Conteneur baguette haut

    styleDivHaut2 = {
      width: cadreLargeurPx2,
      height: baguetteHauteurPx2,
      top: baguetteHauteurPx - recouvrement + 1,
      left: baguetteHauteurPx - recouvrement,
      position: "absolute"
    }; //Conteneur baguette gauche

    styleDivGauche2 = {
      position: "absolute",
      left: baguetteHauteurPx - recouvrement,
      top: baguetteHauteurPx - recouvrement,
      width: baguetteHauteurPx2,
      height: cadreHauteurPx2,
      clipPath: "polygon(" + baguetteHauteurPx2 + "px " + baguetteHauteurPx2 + "px, 0 0, 0 " + cadreHauteurPx2 + "px, " + baguetteHauteurPx2 + "px " + cadreHauteurPx2 + "px)"
    }; //Baguette haut

    styleImageHaut2 = {
      position: "absolute",
      left: 0,
      width: cadreLargeurPx2,
      height: baguetteHauteurPx2
    }; //Baguette gauche

    styleImageGauche2 = {
      position: "relative",
      width: cadreHauteurPx2,
      height: baguetteHauteurPx2,
      transform: "rotate(-90deg)",
      transformOrigin: "center",
      top: cadreHauteurPx2 / 2 - baguetteHauteurPx2 / 2,
      left: 0 - cadreHauteurPx2 / 2 + baguetteHauteurPx2 / 2
    };
  } // CARRES :


  var styleCarreHautGauche = {
    position: "absolute",
    width: largeurCarres,
    height: largeurCarres,
    top: "0px",
    borderStyle: "solid none none none",
    borderWidth: "1px",
    borderColor: "#939191",
    opacity: "0.2",
    transformOrigin: "top left",
    transform: "rotate(45deg)"
  };
  var styleLoader = {
    display: "none",
    background: "white",
    zIndex: 2,
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    textAlign: "center",
    paddingTop: cadreHauteurPx / 2 - 25
  };
  var propsCheckLoaded = {};
  var propsCheckLoaded2 = {};
  propsCheckLoaded["data-image-check-loading-" + uniqueId] = true;
  propsCheckLoaded2["data-image-check-loading-doublo-" + uniqueId] = true;
  var Image = props.imageComponent;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    style: styleCadre
  }, loading || props.baguetteInterieure !== null && loading2 ? /*#__PURE__*/_react.default.createElement("div", {
    style: styleLoader
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "spinner"
  })) : "", /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    style: styleDivHaut
  }, propsCheckLoaded), /*#__PURE__*/_react.default.createElement(Image, {
    key: "previsu-1",
    image: props.image,
    onLoad: function onLoad() {
      setLoading(false);
    },
    style: styleImageHaut,
    alt: "Baguette1"
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: styleDivGauche
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: typeof process.env.PUBLIC_DIR !== "undefined" ? {} : styleImageGauche
  }, /*#__PURE__*/_react.default.createElement(Image, {
    key: "previsu-2",
    image: props.image,
    style: typeof process.env.PUBLIC_DIR !== "undefined" ? styleImageGauche : {},
    alt: "Baguette1"
  }))), props.baguetteInterieure !== null ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    style: styleDivHaut2
  }, propsCheckLoaded2), /*#__PURE__*/_react.default.createElement(Image, {
    key: "previsu-3",
    image: props.baguetteInterieure.imgCoin,
    style: styleImageHaut2,
    onLoad: function onLoad() {
      return setLoading2(false);
    },
    alt: "Baguette1"
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: styleDivGauche2
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: typeof process.env.PUBLIC_DIR !== "undefined" ? {} : styleImageGauche2
  }, /*#__PURE__*/_react.default.createElement(Image, {
    key: "previsu-4",
    image: props.baguetteInterieure.imgCoin,
    style: typeof process.env.PUBLIC_DIR !== "undefined" ? styleImageGauche2 : {},
    alt: "Baguette1"
  })))) : null, /*#__PURE__*/_react.default.createElement("div", {
    style: styleCarreHautGauche
  })));
};

exports.PrevisuCoinCadre = PrevisuCoinCadre;
PrevisuCoinCadre.defaultProps = {
  baguetteInterieure: null,
  width: 188,
  height: 120,
  pageProduit: {
    largeur: 18,
    hauteur: 13
  }
};
PrevisuCoinCadre.propTypes = {
  width: _propTypes.default.number,
  height: _propTypes.default.number,
  baguetteInterieure: _propTypes.default.object,
  baguette: _propTypes.default.object.isRequired,
  imageComponent: _propTypes.default.element.isRequired,
  image: _propTypes.default.object,
  pageProduit: _propTypes.default.object
};
var _default = PrevisuCoinCadre;
exports.default = _default;